/*
 * 策略报告归档只读客户端 / Strategy Report Archive Read-Only Client
 *
 * 文件职责 / File Purpose
 * - 中文：读取中性的策略报告目录，并生成受 BFF 校验的报告制品 URL。
 * - English: Reads the neutral strategy-report catalog and builds BFF-validated artifact URLs.
 *
 * 调用关系 / Call Flow
 * - 中文：正式前端页面只调用 `/api/reports/*`；鉴权、文件名白名单与内容响应由 BFF 负责。
 * - English: Formal pages call only `/api/reports/*`; BFF owns authorization, filename
 *   allowlisting, and artifact responses.
 *
 * 业务与安全边界 / Business and Security Boundary
 * - 中文：本模块不暴露自选股成员、分组、人工提名、旧文件路径或任何写操作，也不直接访问
 *   文件系统。
 * - English: This module exposes no watchlist membership, groups, nomination, legacy paths, or
 *   mutation operations, and it never accesses the filesystem directly.
 */
import { request } from '@umijs/max';

export const getStrategyReportCatalog = () => request(
  '/api/reports/strategy-catalog',
  { credentials: 'include' },
);

export const buildStrategyReportArtifactUrl = (
  filename,
  { inline = false } = {}
) => {
  if (!filename) return '';
  const params = new URLSearchParams({ filename });
  if (inline) params.set('inline', '1');
  return `/api/reports/strategy-artifact?${params.toString()}`;
};
